import { useState, useEffect } from 'react';
import { Outlet, NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { settingsService } from '../../services/api';
import './MainLayout.css';

const icon = (paths) => () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">{paths}</svg>
);

const HomeIcon = icon(<><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9,22 9,12 15,12 15,22" /></>);
const CalendarIcon = icon(<><rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></>);
const ListIcon = icon(<><line x1="8" y1="6" x2="21" y2="6" /><line x1="8" y1="12" x2="21" y2="12" /><line x1="8" y1="18" x2="21" y2="18" /><circle cx="3.5" cy="6" r="1" /><circle cx="3.5" cy="12" r="1" /><circle cx="3.5" cy="18" r="1" /></>);
const UsersIcon = icon(<><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></>);
const TagIcon = icon(<><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" /><line x1="7" y1="7" x2="7.01" y2="7" /></>);
const ClockIcon = icon(<><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></>);
const TeamIcon = icon(<><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /></>);
const SettingsIcon = icon(<><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" /></>);
const LogoutIcon = icon(<><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><polyline points="16,17 21,12 16,7" /><line x1="21" y1="12" x2="9" y2="12" /></>);
const MapPinIcon = icon(<><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" /></>);
const DropsIcon = icon(<><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 7l9 6 9-6" /></>);
const BriefcaseIcon = icon(<><rect x="2" y="7" width="20" height="14" rx="2" ry="2" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" /></>);
const QuoteIcon = icon(<><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14,2 14,8 20,8" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /></>);
const CostsIcon = icon(<><rect x="2" y="5" width="20" height="14" rx="2" ry="2" /><line x1="2" y1="10" x2="22" y2="10" /><line x1="6" y1="15" x2="10" y2="15" /></>);
const ReportIcon = icon(<><line x1="4" y1="20" x2="20" y2="20" /><rect x="6" y="11" width="3" height="7" /><rect x="11" y="6" width="3" height="12" /><rect x="16" y="9" width="3" height="9" /></>);
const PhotoIcon = icon(<><rect x="3" y="3" width="18" height="18" rx="2" ry="2" /><circle cx="8.5" cy="8.5" r="1.5" /><polyline points="21,15 16,10 5,21" /></>);
const MoreIcon = icon(<><rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" /><rect x="3" y="14" width="7" height="7" rx="1.5" /><rect x="14" y="14" width="7" height="7" rx="1.5" /></>);

export default function MainLayout() {
  const { user, logout } = useAuth();
  const [businessName, setBusinessName] = useState('Get It Done');
  const [moreOpen, setMoreOpen] = useState(false); // the phone's "More" sheet (Bug #402)
  const location = useLocation();

  useEffect(() => {
    settingsService.get().then((r) => { if (r.success && r.settings?.business_name) setBusinessName(r.settings.business_name); });
  }, []);
  useEffect(() => { setMoreOpen(false); }, [location.pathname]);
  useEffect(() => {
    if (!moreOpen) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') setMoreOpen(false); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [moreOpen]);

  // `mobile: true` = one of the four bar slots on the phone; everything else sits behind "More".
  // Drops is on the bar because the walk list is used on the phone (Bug #402).
  const navItems = [
    { path: '/', label: 'Dashboard', icon: HomeIcon, mobile: true },
    { path: '/calendar', label: 'Calendar', icon: CalendarIcon, mobile: true },
    { path: '/appointments', label: 'Appointments', icon: ListIcon },
    { path: '/jobs', label: 'Jobs', icon: BriefcaseIcon, mobile: true },
    { path: '/quotes', label: 'Quotes', icon: QuoteIcon },
    { path: '/business-costs', label: 'Business costs', icon: CostsIcon },
    { path: '/reports', label: 'Reports', icon: ReportIcon },
    { path: '/clients', label: 'Clients', icon: UsersIcon },
    { path: '/map', label: 'Map', icon: MapPinIcon },
    { path: '/drops', label: 'Drops', icon: DropsIcon, mobile: true },
    { path: '/gallery', label: 'Gallery', icon: PhotoIcon },
    { path: '/services', label: 'Job Types', icon: TagIcon },
    { path: '/availability', label: 'Availability', icon: ClockIcon },
    ...(user?.role === 'owner' ? [{ path: '/team', label: 'Team', icon: TeamIcon }] : []),
    { path: '/settings', label: 'Settings', icon: SettingsIcon }
  ];
  const mobileItems = navItems.filter((i) => i.mobile).slice(0, 4);
  const moreItems = navItems.filter((i) => !mobileItems.includes(i));
  const moreActive = moreItems.some((i) => location.pathname === i.path || location.pathname.startsWith(`${i.path}/`));

  return (
    <div className="main-layout">
      <aside className="sidebar">
        <div className="sidebar-header">
          <div className="logo">
            <span className="logo-mark">📅</span>
            <span className="logo-text">{businessName}</span>
          </div>
        </div>

        <nav className="sidebar-nav">
          {navItems.map(({ path, label, icon: Icon }) => (
            <NavLink key={path} to={path} className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`} end={path === '/'}>
              <Icon /><span>{label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="user-info"><span className="user-name">{user?.name || 'User'}</span></div>
          <button className="logout-btn" onClick={logout}><LogoutIcon /><span>Logout</span></button>
        </div>
      </aside>

      <main className="main-content"><Outlet /></main>

      {moreOpen && <div className="mobile-more-backdrop" onClick={() => setMoreOpen(false)} />}
      {moreOpen && (
        <div className="mobile-more" id="mobile-more" role="dialog" aria-label="More pages">
          <div className="mobile-more-grid">
            {moreItems.map(({ path, label, icon: Icon }) => (
              <NavLink key={path} to={path} className={({ isActive }) => `mobile-more-item ${isActive ? 'active' : ''}`} onClick={() => setMoreOpen(false)}>
                <Icon /><span>{label}</span>
              </NavLink>
            ))}
            <button type="button" className="mobile-more-item logout" onClick={() => { setMoreOpen(false); logout(); }}><LogoutIcon /><span>Logout</span></button>
          </div>
          <p className="mobile-more-user">{user?.name || 'User'}</p>
        </div>
      )}
      <nav className="mobile-nav">
        {mobileItems.map(({ path, label, icon: Icon }) => (
          <NavLink key={path} to={path} className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`} end={path === '/'}>
            <Icon /><span>{label}</span>
          </NavLink>
        ))}
        <button type="button" className={`mobile-nav-item ${moreOpen || moreActive ? 'active' : ''}`} onClick={() => setMoreOpen((o) => !o)} aria-expanded={moreOpen} aria-controls="mobile-more">
          <MoreIcon /><span>More</span>
        </button>
      </nav>
    </div>
  );
}
